<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="状态：">
        <el-select v-model="query.status" placeholder="请选择" clearable size="small">
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入驻时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        status:undefined
      },
      topicClassOptions: [],
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      let query={...this.query}
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : ""
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : ""
      if(!this.query.status){
        query.status=-1
      }
      return this.$common.confirm('是否确认导出')
        .then(() => cityCompanyApi.exportExcel(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
